var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('div',{staticClass:"body-1 logo__headline"},[_vm._t("default")],2),_c('img',{attrs:{"src":require(("@/assets/" + _vm.logo + ".svg")),"alt":"Aladin logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }